module.exports = __webpack_public_path__ + "img/edit.1094e219.svg";